import React, { useMemo } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import CustomerInputGroup from '../../../common/forms/CustomerInputGroup';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateKidAge } from '../../../../utils/validators';
import { enumToSelectOptions } from '../../../../utils/enum';
import Select from '../../../common/forms/select/Select';
import TextInput from '../../../common/forms/input/TextInput';
import {
  RELATIONSHIP,
  RELATIONSHIP_WITH_PERMIT,
} from '../../../../config/constants';

const KidPassengerForm = ({ passenger, form }) => {
  const [needNotarizedPermit, setNeedNotarizedPermit] = React.useState(false);
  const [customerChanged, setCustomerChanged] = React.useState(false);
  const validations = useMemo(
    () => [validateKidAge(5), isRequired],
    [customerChanged],
  );

  const onChangeRelationship = (relationship) => {
    if (relationship && relationship.label) {
      setNeedNotarizedPermit(
        Object.values(RELATIONSHIP_WITH_PERMIT).some(
          (r) => r.label === relationship.label,
        ),
      );
    } else {
      setNeedNotarizedPermit(false);
    }
  };

  return (
    <>
      <CustomerInputGroup
        label="Menor de Edad"
        labelRequired
        name={`${passenger}.kid.customer`}
        form={form}
        validate={validations}
        onEditOrSaveCustomer={(customer) =>
          setCustomerChanged((previous) => !previous)
        }
        showDetails
      />
      <FormGroup row>
        <FormItem label="Relación con el Menor" required>
          <Field
            name={`${passenger}.kid.relationship`}
            component={Select}
            options={enumToSelectOptions(RELATIONSHIP)}
            onChange={onChangeRelationship}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {needNotarizedPermit && (
        <>
          <div className="alert alert-info">
            <i className="fa fa-info-circle mr-2" />
            Se requiere permiso notariado para que el menor pueda viajar.
          </div>
          <FormGroup row>
            <FormItem label="Permiso Notariado">
              <Field
                name={`${passenger}.kid.notarizedPermit`}
                component={TextInput}
                type="text"
                placeholder="Ingresar Permiso Notariado"
              />
            </FormItem>
          </FormGroup>
        </>
      )}
      <FormGroup row>
        <FormItem label="Observaciones">
          <Field
            name={`${passenger}.kid.comments`}
            component={TextInput}
            type="textarea"
            placeholder="Observaciones"
          />
        </FormItem>
      </FormGroup>
    </>
  );
};

KidPassengerForm.propTypes = {
  passenger: PropTypes.string.isRequired,
  form: PropTypes.string.isRequired,
};

export default KidPassengerForm;
